import React from 'react';
import BrandMark from '../components/BrandMark';
import PlayCta from '../components/PlayCta';
import { SiteFooter, SiteHeader } from '../components/SiteChrome';
import { SITE } from '../config/site';
import '../Landing.css';

const STEPS = [
  {
    n: '1',
    title: 'Įveskite vaistą',
    text: 'Pridėkite vartojamą vaistą į programėlę.',
    icon: 'pill',
  },
  {
    n: '2',
    title: 'Nustatykite laiką',
    text: 'Pasirinkite, kada telefonas turi priminti.',
    icon: 'clock',
  },
  {
    n: '3',
    title: 'Gaukite priminimą',
    text: 'Atėjus nustatytam laikui telefonas pateiks priminimą.',
    icon: 'bell',
  },
  {
    n: '4',
    title: 'Pažymėkite, kad išgėrėte',
    text: 'Programėlėje galėsite pažymėti atliktą vartojimą ir vėliau peržiūrėti istoriją.',
    icon: 'check',
  },
];

const FEATURES = [
  {
    title: 'Vaistų priminimai',
    text: 'Nustatykite atskirą laiką kiekvienam vaistui.',
    icon: 'bell',
  },
  {
    title: 'Lankstus grafikas',
    text: 'Naudokite programėlę pagal savo vaistų vartojimo rutiną.',
    icon: 'clock',
  },
  {
    title: 'Pažymėjimas „Išgerta“',
    text: 'Pažymėkite, kada vaistą jau išgėrėte.',
    icon: 'check',
  },
  {
    title: 'Vartojimo istorija',
    text: 'Peržiūrėkite ankstesnius pažymėjimus vienoje vietoje.',
    icon: 'list',
  },
  {
    title: 'Keli vaistai',
    text: 'Patogu, kai skirtingus vaistus reikia vartoti skirtingu metu.',
    icon: 'pill',
  },
  {
    title: 'Paprasta lietuvių kalba',
    text: 'Aiški sąsaja be nereikalingo sudėtingumo.',
    icon: 'text',
  },
];

const SCREENSHOTS = [
  { file: '01-pagrindinis.png', caption: 'Pagrindinis ekranas', alt: 'IšgerkVaistus pagrindinis ekranas su šiandienos priminimais' },
  { file: '02-pridejimas.png', caption: 'Naujo vaisto pridėjimas', alt: 'Naujo priminimo pridėjimo ekranas su pavadinimu Vitaminas D' },
  { file: '03-laikas.png', caption: 'Laiko nustatymas', alt: 'Priminimo laiko ir kartojimo nustatymo ekranas' },
  { file: '04-priminimas.png', caption: 'Priminimas', alt: 'IšgerkVaistus priminimas telefone' },
  { file: '05-isgerta.png', caption: 'Pažymėjimas „Išgerta“', alt: 'Priminimas pažymėtas kaip atliktas' },
  { file: '06-istorija.png', caption: 'Vartojimo ataskaita', alt: 'Ataskaitos laikotarpio pasirinkimas programėlėje' },
];

const FAQ = [
  {
    q: 'Kaip sukurti priminimą?',
    a: 'Pagrindiniame ekrane pasirinkite „Pridėti priminimą“, įveskite pavadinimą, valandą ir minutes, tada išsaugokite.',
  },
  {
    q: 'Ką reiškia „Supratau“?',
    a: 'Tai patvirtina, kad matėte priminimą. Tai nėra tas pats kaip „Išgėriau“.',
  },
  {
    q: 'Kaip pažymėti „Išgėriau“?',
    a: 'Priminimo kortelėje arba priminimo lange pasirinkite „Išgėriau“. Taip pažymima, kad vaistą išgėrėte.',
  },
  {
    q: 'Kaip tvarkyti prenumeratą?',
    a: 'Programėlėje eikite į Pagalba → Tvarkyti prenumeratą. Atsidarys saugus Stripe puslapis.',
  },
  {
    q: 'Kaip nutraukti prenumeratą?',
    a: 'Pagalba → Tvarkyti prenumeratą, tada Stripe portale nutraukite prenumeratą. Programėlė paprastai veikia iki jau apmokėto laikotarpio pabaigos.',
  },
  {
    q: 'Kaip ištrinti paskyrą?',
    a: `Pagalba → Ištrinti paskyrą. Jei prenumerata vis dar aktyvi, pirmiausia ją nutraukite. Taip pat galite naudoti ${SITE.url}/delete-account arba parašyti ${SITE.contactEmail}.`,
  },
  {
    q: 'Ką daryti, jei pranešimai neveikia?',
    a: `Telefono nustatymuose leiskite IšgerkVaistus pranešimus. Android 12+ taip pat leiskite tikslius signalus. Jei vis tiek neveikia, parašykite ${SITE.contactEmail}.`,
  },
  {
    q: 'Kaip susisiekti?',
    a: `Rašykite ${SITE.contactEmail}.`,
  },
  {
    q: 'Ar IšgerkVaistus teikia medicinines rekomendacijas?',
    a: 'Ne. Tai pagalbinė priminimų priemonė. Dėl vaistų klauskite gydytojo arba vaistininko.',
  },
];

function StepIcon({ name }) {
  return (
    <svg className="step-icon" viewBox="0 0 48 48" aria-hidden="true">
      {name === 'pill' && (
        <>
          <rect x="8" y="18" width="32" height="12" rx="6" fill="#1565C0" />
          <rect x="8" y="18" width="16" height="12" rx="6" fill="#90CAF9" />
        </>
      )}
      {name === 'clock' && (
        <>
          <circle cx="24" cy="24" r="14" fill="none" stroke="#1565C0" strokeWidth="3" />
          <path d="M24 16v9l6 4" fill="none" stroke="#1565C0" strokeWidth="3" strokeLinecap="round" />
        </>
      )}
      {name === 'bell' && (
        <>
          <path d="M16 22a8 8 0 1 1 16 0v6l3 4H13l3-4z" fill="#F5C518" stroke="#1565C0" strokeWidth="2" />
          <circle cx="24" cy="34" r="2.5" fill="#1565C0" />
        </>
      )}
      {name === 'check' && (
        <>
          <circle cx="24" cy="24" r="14" fill="#E3F2FD" />
          <path d="M16 24l5 5 11-12" fill="none" stroke="#1565C0" strokeWidth="3" strokeLinecap="round" />
        </>
      )}
      {name === 'list' && (
        <>
          <path d="M14 16h20M14 24h20M14 32h14" fill="none" stroke="#1565C0" strokeWidth="3" strokeLinecap="round" />
        </>
      )}
      {name === 'text' && (
        <>
          <rect x="12" y="12" width="24" height="24" rx="4" fill="#E3F2FD" />
          <path d="M16 20h16M16 26h12" fill="none" stroke="#1565C0" strokeWidth="2.5" strokeLinecap="round" />
        </>
      )}
    </svg>
  );
}

function ScreenshotSlot({ caption, file, alt }) {
  return (
    <figure className="shot-card">
      <div className="shot-frame">
        <img src={`/screenshots/${file}`} alt={alt || caption} />
      </div>
      <figcaption>{caption}</figcaption>
    </figure>
  );
}

export default function LandingPage() {
  return (
    <div className="landing">
      <a className="skip-link" href="#turinys">
        Pereiti prie turinio
      </a>
      <SiteHeader />

      <main id="turinys">
        <section className="hero" id="pradzia">
          <div className="hero-copy">
            <p className="hero-brand">
              <BrandMark size={36} />
              IšgerkVaistus
            </p>
            <h1>
              Laikas vaistams?
              <br />
              Telefonas primins.
            </h1>
            <p className="hero-lead">
              Paprasta lietuviška programėlė, primenanti, kada laikas išgerti vaistus.
            </p>
            <p className="hero-extra">
              Nustatykite vaisto vartojimo laiką, gaukite priminimą ir pažymėkite, kad vaistus
              išgėrėte.
            </p>
            <p className="hero-problem">
              Nebereikia svarstyti: „Ar šiandien jau išgėriau vaistus?“
            </p>
            <p className="hero-extra">
              Pažymėkite išgertus vaistus programėlėje ir prireikus pasitikrinkite vartojimo
              istoriją.
            </p>
            <div className="hero-actions" id="atsisiusti">
              <PlayCta />
            </div>
            <p className="hero-note">Android telefonams • Lietuvių kalba</p>
          </div>
          <div className="hero-visual">
            <div className="phone-shell">
              <div className="phone-notch" />
              <div className="phone-screen">
                <img
                  src="/screenshots/01-pagrindinis.png"
                  alt="IšgerkVaistus programėlės pagrindinis ekranas telefone"
                />
              </div>
            </div>
          </div>
        </section>

        <section className="section" id="kaip-veikia">
          <h2>Kaip veikia</h2>
          <p className="section-intro">Keturi paprasti žingsniai.</p>
          <ol className="steps">
            {STEPS.map((step) => (
              <li key={step.n} className="step-card">
                <StepIcon name={step.icon} />
                <span className="step-n">{step.n}</span>
                <h3>{step.title}</h3>
                <p>{step.text}</p>
              </li>
            ))}
          </ol>
        </section>

        <section className="section section-alt" id="galimybes">
          <h2>Pagrindinės galimybės</h2>
          <div className="feature-grid">
            {FEATURES.map((feature) => (
              <article key={feature.title} className="feature-card">
                <StepIcon name={feature.icon} />
                <h3>{feature.title}</h3>
                <p>{feature.text}</p>
              </article>
            ))}
          </div>
        </section>

        <section className="section parents" id="tevams">
          <div className="parents-card">
            <div className="parents-graphic" aria-hidden="true">
              <BrandMark size={72} />
              <span>Kartu nustatyti priminimus</span>
            </div>
            <div className="parents-copy">
              <h2>Padėkite tėvams susikurti vaistų priminimus</h2>
              <p>
                Jeigu mama, tėtis ar kitas artimas žmogus reguliariai vartoja vaistus, galite padėti
                įdiegti programėlę jo telefone ir kartu nustatyti reikalingus priminimus.
              </p>
              <p>
                Paprasta lietuviška sąsaja sukurta taip, kad pagrindinius veiksmus būtų lengva
                suprasti.
              </p>
            </div>
          </div>
        </section>

        <section className="section" id="ekranvaizdziai">
          <h2>Kaip atrodo IšgerkVaistus</h2>
          <p className="section-intro">Tikri programėlės ekranai iš IšgerkVaistus.</p>
          <div className="shots">
            {SCREENSHOTS.map((shot) => (
              <ScreenshotSlot key={shot.file} {...shot} />
            ))}
          </div>
        </section>

        <section className="section section-alt" id="kaina">
          <h2>Paprasta prenumerata</h2>
          <p className="trial-highlight">
            {SITE.trialDays} dienų nemokamas bandymas – kortelės nereikia.
          </p>
          <p className="section-intro">Vėliau galite pasirinkti planą programėlėje.</p>
          <div className="price-row">
            <article className="price-card">
              <h3>Mėnesinis planas</h3>
              <p className="price">{SITE.plans.monthlyPrice}</p>
            </article>
            <article className="price-card">
              <h3>Metinis planas</h3>
              <p className="price">{SITE.plans.yearlyPrice}</p>
            </article>
          </div>
        </section>

        <section className="section" id="duk">
          <h2>Dažnai užduodami klausimai</h2>
          <div className="faq">
            {FAQ.map((item) => (
              <details key={item.q}>
                <summary>{item.q}</summary>
                <p>{item.a}</p>
              </details>
            ))}
          </div>
        </section>

        <section className="final-cta">
          <h2>Paprastesnė vaistų vartojimo rutina prasideda nuo priminimo.</h2>
          <PlayCta />
        </section>
      </main>

      <SiteFooter />
    </div>
  );
}
